import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

import CCADetails from "./CCADetails";

class NotComplianceReport extends SmartModel {
	static STATUS_OPEN = 1;
	static STATUS_WAITING_CS_DETAILS = 4;
	static STATUS_CLOSED = 3;
	static STATUS_CS_READY_TO_START = 5;
	static STATUS_CS_RUNNING = 6;

	csApplicatorTeamGuid = ""; //Join field
	
	__csApplicatorTeam = "";
	__followUpList = [];
	__hasNewFollowUp = false;
	__invoicingStatusCustomerLabel = "";
	__invoicingStatusCustomerNoteIcon = "";
	__isUnderWarranty = false;
	// __hilited = false;
	__numberLabel = "(Il numero verrà assegnato dal sistema al salvataggio)";
	__paymentStatusApplicatorTeamLabel = "";
	__paymentStatusApplicatorTeamNoteIcon = "";
	__paymentStatusCustomerLabel = "";
	__paymentStatusCustomerNoteIcon = "";
	__render = true;
	__totalAttachmentsCount = 0;
	__updatedAt = "";
	__updatedAtLabel = "";
	__warrantyMonths = 0;

	constructor (data) {
		super();
		
		this.applicatorTeamId = "";
		this.attachmentFolderGuid = "";
		this.cca = "";
		this.ccaDetailsGuid = "";
		this.ccaDetails = {}; //Join field
		this.clientGuid = "";
		this.clientName = "";
		this.conclusionDate = "0000-00-00 00:00:00";
		this.considerAsUnderWarranty = false;
		this.constructionSiteEndDate = "0000-00-00 00:00:00";
		this.constructionSiteGuid = "";
		this.constructionSiteStartDate = "0000-00-00 00:00:00";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.extraData = {
			constructioSiteLotId: -1,
			constructionSiteWorksheetDocumentGuid: "",
			quotationCCA: "",
			relatedGuids: {
				clientGuid: "",
				quotationGuid: "",
				notComplianceReportGuid: "",
				constructioSiteGuid: "",
				constructioSiteCardGuid: "",
				constructioSiteFolderGuid: "",
				projectFolderGuid: "",
				siteInfoSheetGuid: "",
				teamCloseDocumentGuid: "",
				visitGuid: "",
			},
		};
		this.furtherNotes = "";
		this.furtherNotesIPM = "";
		this.guid = "";
		this.invoicingNoteCustomer = "";
		this.invoicingStatusCustomer = 0;
		this.latestFollowUp = "";
		this.lot = "";
		this.newFollowUpCount = 0;
		this.notComplianceData = {
			attachments: [],
			installationError: false,
			managedWith: "",
			materialProblem: false,
			notSuitableEnvConditions: false,
			otherProblems: false,
			problemAnalysisAndDescription: "",
			problemAnalysisAndDescriptionIPM: "",
			referenceDate: "0000-00-00 00:00:00",
			reportedBy: "",
			rqa: "",
			surfacePreparationError: false,
		};
		this.number = 0;
		this.paymentNoteApplicatorTeam = "";
		this.paymentNoteCustomer = "";
		this.paymentStatusApplicatorTeam = 0;
		this.paymentStatusCustomer = 0;
		this.reportDate = "0000-00-00 00:00:00";
		this.requestedArea = 0;
		this.rqa = "";
		this.spoiledArea = 0;
		this.spoiledProductList = []; // { name: "", lot: "", storeMethod: "" }
		this.status = 0;//[1: Aperta, 2: Completa, 3: Conclusa, 4: In attesa di CCA/WSD, 5: CS pronto a partire, 6 CS in corso]
		this.systems = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
		this.userGuid = "";
		this.siteLocation = {
			address: "",
			buyers: "",
			city: "",
			constructionCompanies: "",
			designers: "",
			interventionAreas: "",
			logisticNotes: "",
			name: "",
			personInCharge: {
				name: "",
				eMail: "",
				phone: ""
			},
			province: "",
			region: "",
			zip: "",
		},
		this.verificationData = {
			successfullyManaged: null,
			correctiveAction: false,
			correctiveActionDescription: "",
			correctiveActionNumber: "",
			consequences: "",
			consequencesIPM: "",
		};
		this.warrantyData = {
			attachments: [],
			dtecApproved: false,
			dtecDecidedInterventionDescription: false,
			dtecInterventionDescription: "",
			dtecInterventionDescriptionIPM: "",
			interventionDescription: "",
			interventionDescriptionIPM: "",
			paymentStatus: 0, //1: Regolare, 2: Bloccato
			requestASAP: false,
			requestChristmas: false,
			requestedEndDate: "0000-00-00 00:00:00",
			requestMidaugust: false,
			requestedStartDate: "0000-00-00 00:00:00",
			requestWeekEnd: false,
			referenceDate: "0000-00-00 00:00:00",
			rqa: "",
		};

		this.__followUpList = [];
		this.__hasNewFollowUp = false;
		this.__invoicingStatusCustomerNoteIcon = "";
		this.__isUnderWarranty = false;
		// this.__hilited = false;
		this.__numberLabel = "(Il numero verrà assegnato dal sistema al salvataggio)";
		this.__paymentStatusApplicatorTeamNoteIcon = "";
		this.__paymentStatusCustomerNoteIcon = "";
		this.__render = true;
		this.__updatedAt = "";
		this.__updatedAtLabel = "";
		this.__warrantyMonths = 0;

		if (data) {
			//Dave.Warn: Questo import non mantiene i valori di default espressi sopra, verifica perché e risolvi.
			this.import(data);
		}
	}

	export () {
		var exportData = this.__export();

		exportData.conclusionDate = this.exportDateField("conclusionDate");
		exportData.considerAsUnderWarranty = this.exportBooleanField("considerAsUnderWarranty");
		exportData.constructionSiteEndDate = this.exportDateField("constructionSiteEndDate");
		exportData.constructionSiteStartDate = this.exportDateField("constructionSiteStartDate");
		exportData.createdAt = this.exportDateField("createdAt");
		exportData.extraData = this.exportObjectField("extraData");
		
		const notComplianceData = Object.assign({}, this.notComplianceData);
		notComplianceData.referenceDate = this.exportDateField("notComplianceData.referenceDate");
		exportData.notComplianceData = JSON.stringify(notComplianceData);

		exportData.reportDate = this.exportDateField("reportDate");
		
		const spoiledProductList = this.spoiledProductList.map(item => item.export());
		exportData.spoiledProductList = JSON.stringify(spoiledProductList);//this.exportArrayField("spoiledProductList");
		exportData.updateAt = this.exportDateField("updateAt");
		exportData.siteLocation = this.exportObjectField("siteLocation");
		exportData.verificationData = this.exportObjectField("verificationData");

		const warrantyData = Object.assign({}, this.warrantyData);
		warrantyData.requestedEndDate = this.exportDateField("warrantyData.requestedEndDate");
		warrantyData.requestedStartDate = this.exportDateField("warrantyData.requestedStartDate");
		warrantyData.referenceDate = this.exportDateField("warrantyData.referenceDate");
		exportData.warrantyData = JSON.stringify(warrantyData);

		return exportData;
	}

	evaluateSiteLocationLabel () {
		if (this.siteLocation.name !== "") {
			this.__siteLocationLabel = this.siteLocation.name;
		}
		else {
			this.__siteLocationLabel = "Sede Legale";
		}

		if (this.siteLocation.interventionAreas !== "") {
			this.__siteLocationLabel += " - " + this.siteLocation.interventionAreas;
		}
	}

	import (data, options) {
		this.__import(data, options);

		
		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAt = this.createdAt.format("YYYY-MM-DD");
			this.__createdAtLabel = this.createdAt.format("DD/MM/YYYY");
		}

		if (this.importDateField("conclusionDate", data.conclusionDate)) {
			this.__conclusionDate = this.conclusionDate.format("YYYY-MM-DD");
			this.__conclusionDateLabel = this.conclusionDate.format("DD/MM/YYYY");
		}

		this.importBooleanField("considerAsUnderWarranty", data.considerAsUnderWarranty);

		if (this.importDateField("constructionSiteEndDate", data.constructionSiteEndDate)) {
			this.__constructionSiteEndDate = this.constructionSiteEndDate.format("YYYY-MM-DD");
			this.__constructionSiteEndDateLabel = this.constructionSiteEndDate.format("DD/MM/YYYY");
		}
		if (this.importDateField("constructionSiteStartDate", data.constructionSiteStartDate)) {
			this.__constructionSiteStartDate = this.constructionSiteStartDate.format("YYYY-MM-DD");
			this.__constructionSiteStartDateLabel = this.constructionSiteStartDate.format("DD/MM/YYYY");
		}

		this.importNumberField("invoicingStatusCustomer", data.invoicingStatusCustomer);

		// if (typeof data.latestFollowUp === "string") {
		// 	this.latestFollowUp = data.latestFollowUp;
		// }
		this.importNumberField("newFollowUpCount", data.newFollowUpCount);

		if (this.importDateField("notComplianceData.referenceDate", this.notComplianceData.referenceDate)) {
			this.__notComplianceReferenceDate = this.notComplianceData.referenceDate.format("YYYY-MM-DD");
			this.__notComplianceReferenceDateLabel = this.notComplianceData.referenceDate.format("DD/MM/YYYY");
		}

		this.importNumberField("paymentStatusApplicatorTeam", data.paymentStatusApplicatorTeam);
		this.importNumberField("paymentStatusCustomer", data.paymentStatusCustomer);

		if (this.importDateField("reportDate", this.reportDate)) {
			this.__reportDate = this.reportDate.format("YYYY-MM-DD");
			this.__reportDateLabel = this.reportDate.format("DD/MM/YYYY");
		}

		this.importNumberField("requestedArea", data.requestedArea);
		this.importNumberField("spoiledArea", data.spoiledArea);

		this.spoiledProductList = this.spoiledProductList.map((item, index) => {
			// console.log({item})
			return Shark.getInstance("__smart__", {
				customStorageType: item.customStorageType,
				lot: item.lot,
				product: item.product,
				storageType: item.storageType,
				__index: index,
			});
		});

		this.importNumberField("status", data.status);

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
		}

		if (this.importDateField("warrantyData.requestedEndDate", this.warrantyData.requestedEndDate)) {
			this.__warrantyInterventionRequestedEndDate = this.warrantyData.requestedEndDate.format("YYYY-MM-DD");
			this.__warrantyInterventionRequestedEndDateLabel = this.warrantyData.requestedEndDate.format("DD/MM/YYYY");
		}
		if (this.importDateField("warrantyData.requestedStartDate", this.warrantyData.requestedStartDate)) {
			this.__warrantyInterventionRequestedStartDate = this.warrantyData.requestedStartDate.format("YYYY-MM-DD");
			this.__warrantyInterventionRequestedStartDateLabel = this.warrantyData.requestedStartDate.format("DD/MM/YYYY");
		}
		if (this.importDateField("warrantyData.referenceDate", this.warrantyData.referenceDate)) {
			this.__warrantyReferenceDate = this.warrantyData.referenceDate.format("YYYY-MM-DD");
			this.__warrantyReferenceDateLabel = this.warrantyData.referenceDate.format("DD/MM/YYYY");
		}
		
		this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		this.__hasNewFollowUp = this.newFollowUpCount > 0;

		if (this.guid !== "") {
			this.__numberLabel = this.number + "/" + this.reportDate.format("YYYY");
			this.__teamUpId = this.reportDate.format("YYYY") + "-" + this.number;
		}

		this.__statusLabel = Shark.get("notComplianceReportStatusMap")[this.status];
		// if (this.status === 2) {
		// 	this.__statusLabel += "<br><small>(manca chiusura squadra)</small>";
		// }

		if (this.notComplianceData.referenceDate.isValid() && this.constructionSiteEndDate.isValid()) {
			this.__warrantyMonths = this.notComplianceData.referenceDate.clone().set({hour: 0, minute: 0, seconds: 0}).diff(this.constructionSiteEndDate.clone().set({hour: 0, minute: 0, seconds: 0}), "M");
			this.__isUnderWarranty = this.__warrantyMonths < 24;
		}
		// this.__reportData.agentName = this.registry.siteIPMPersonInCharge;
		// this.__reportData.province = this.registry.clientProvince;
		// this.__reportData.sector = this.registry.clientCommoditySector;

		const agentList = Shark.get("agentList");
		if (agentList) {
			const currAgent = Utils.safp(agentList, "guid", this.userGuid);
			if (currAgent) {
				this.__agentName = currAgent.__fullName;
			}
		}
		const clientList = Shark.get("clientList");
		if (clientList) {
			const currClient = Utils.safp(clientList, "guid", this.clientGuid);
			if (currClient) {
				this.__clientName = currClient.name;
			}
		}

		const applicatorTeamList = Shark.get("applicatorTeamList");
		if (applicatorTeamList) {
			const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.applicatorTeamId);
			if (currApplicatorTeam) {
				this.__applicatorTeamName = currApplicatorTeam.name;
			}
		}

		// if (typeof data.latestFollowUp === "string") {
		// 	this.latestFollowUp = data.latestFollowUp;
		// 	this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		// }

		// if (data.attachments && data.attachments !== "") {
		// 	this.attachments = Utils.parseJSON(data.attachments, "array");
		// 	//Dave,ToDo; Occhio alla schifezza
		// 	if (this.attachments.length > 0 && typeof this.attachments[0] === "string") {
		// 		this.attachments = this.attachments.map(item => {
		// 			return {
		// 				label: item.substr(item.lastIndexOf("/") + 1),
		// 				thumbURL: ["jpg", "png"].indexOf(item.substr(item.lastIndexOf(".") + 1)) === -1 ? "/images/icons/" + item.substr(item.lastIndexOf(".") + 1) + ".png" : Shark.get("__cdnURL") + "/" + item,//.replace("ublic", "public"),
		// 				type: item.substr(item.lastIndexOf(".") + 1),
		// 				url: Shark.get("__cdnURL") + "/" + item,//.replace("ublic", "public")
		// 			}
		// 		});
		// 		this.__firstPictureUrl = this.attachments[0];
		// 	}
		// }

		if (this.csApplicatorTeamGuid && this.csApplicatorTeamGuid !== "") {
			const applicatorTeamList = Shark.get("applicatorTeamList");

			if (applicatorTeamList) {
				const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.csApplicatorTeamGuid);
			
				if (currApplicatorTeam) {
					this.__csApplicatorTeam = currApplicatorTeam.name;
				}
			}
		}

		
		this.evaluateSiteLocationLabel();
		this.parseAttachments();
		this.parseCCADetails();
		this.parseConstructionSiteLots();
		this.parseInvoicingStatus();
		this.parsePaymentStatus();
		this.parseStatus();
	}

	onDataChanged(data) {
		switch (data.property) {
			case "__followUpList":
				this.__hasFollowUp = this.__followUpList.length > 0;
				break;
			case "__conclusionDate":
				this.conclusionDate = moment(data.newValue);
				break;
			case "__notComplianceReferenceDate":
				this.notComplianceData.referenceDate = moment(data.newValue);
				break;
			case "__warrantyInterventionRequestedEndDate":
				this.warrantyData.requestedEndDate = moment(data.newValue);
				break;
			case "__warrantyInterventionRequestedStartDate":
				this.warrantyData.requestedStartDate = moment(data.newValue);
				break;
			case "__warrantyReferenceDate":
				this.warrantyData.referenceDate = moment(data.newValue);
				break;
		}
	}

	onVerificationData_successfullyManagedChanged () {
		this.verificationData.successfullyManaged = this.verificationData.successfullyManaged === "true";
	}

	parseAttachments() {
		this.__totalAttachmentsCount = this.notComplianceData.attachments.length + this.warrantyData.attachments.length;
	}

	parseCCADetails () {
		if (this.ccaDetailsGuid !== "") {
			this.ccaDetails = new CCADetails(this.ccaDetails);
		}
	}

	parseConstructionSiteLots () {
		if (this.extraData.constructioSiteLotId !== undefined) {
			if (this.extraData.constructioSiteLotId > -1) {
				this.__lotId = this.extraData.constructioSiteLotId;
				this.__lotIdLabel = "Lotto #" + (this.extraData.constructioSiteLotId + 1);
			}
			else {
				this.__lotId = -1;
				this.__lotIdLabel = "Lotto unico";
			}
		}
		else {
			this.__lotId = -1;
			this.__lotIdLabel = "Lotto unico";
		}
	}

	parseInvoicingStatus () {
		this.__invoicingStatusCustomerLabel = Shark.get("notComplianceReportInvoicingStatusMap")[this.invoicingStatusCustomer];

		switch (this.invoicingStatusCustomer) {
			case 0:
				this.__invoicingStatusCustomerBadgeCSSClass = "badge-info";
				break;
			case 1:
				this.__invoicingStatusCustomerBadgeCSSClass = "badge-success";
				break;
			case 2:
				this.__invoicingStatusCustomerBadgeCSSClass = "badge-warning";
				break;
			case 3:
				this.__invoicingStatusCustomerBadgeCSSClass = "badge-danger";
				break;
		}

		if (this.invoicingNoteCustomer) {
			this.__invoicingStatusCustomerNoteIcon = ` <span class="icon-info-circle ml-2"></span>`;
			this.__invoicingStatusCustomerBadgeCSSClass += " cursor-pointer";
		}
	}

	parsePaymentStatus () {
		this.__paymentStatusApplicatorTeamLabel = Shark.get("notComplianceReportPaymentStatusMap")[this.paymentStatusApplicatorTeam];
		this.__paymentStatusCustomerLabel = Shark.get("notComplianceReportPaymentStatusMap")[this.paymentStatusCustomer];

		switch (this.paymentStatusApplicatorTeam) {
			case 0:
				this.__paymentStatusApplicatorTeamBadgeCSSClass = "badge-info";
				break;
			case 1:
			case 2:
				this.__paymentStatusApplicatorTeamBadgeCSSClass = "badge-success";
				break;
			case 3:
				this.__paymentStatusApplicatorTeamBadgeCSSClass = "badge-warning";
				break;
			case 4:
				this.__paymentStatusApplicatorTeamBadgeCSSClass = "badge-danger";
				break;
		}

		switch (this.paymentStatusCustomer) {
			case 0:
				this.__paymentStatusCustomerBadgeCSSClass = "badge-info";
				break;
			case 1:
			case 2:
				this.__paymentStatusCustomerBadgeCSSClass = "badge-success";
				break;
			case 3:
				this.__paymentStatusCustomerBadgeCSSClass = "badge-warning";
				break;
			case 4:
				this.__paymentStatusCustomerBadgeCSSClass = "badge-danger";
				break;
		}

		if (this.paymentNoteApplicatorTeam) {
			this.__paymentStatusApplicatorTeamNoteIcon = ` <span class="icon-info-circle ml-2"></span>`;
			this.__paymentStatusApplicatorTeamBadgeCSSClass += " cursor-pointer";
		}
		if (this.paymentNoteCustomer) {
			this.__paymentStatusCustomerNoteIcon = ` <span class="icon-info-circle ml-2"></span>`;
			this.__paymentStatusCustomerBadgeCSSClass += " cursor-pointer";
		}
	}

	parseStatus () {
		this.__status_open = this.status === NotComplianceReport.STATUS_OPEN;
		this.__status_closed = this.status === NotComplianceReport.STATUS_CLOSED;
		this.__status_waiting_cs_details = this.status === NotComplianceReport.STATUS_WAITING_CS_DETAILS;

		this.__showSetAsReadyForConstructionSite = this.__status_open;
		this.__showCCAAndWDS = !this.__status_open;
	}

	validate () {
		const errors = [];

		// if (this.siteSqMToCover.trim() === "") {
		// 	errors.push("Non hai indicato la superficie da coprire");
		// }

		if (this.verificationData.successfullyManaged === false && this.verificationData.consequencesIPM.trim() === "" && this.verificationData.consequences.trim() === "") {
			errors.push("Hai indicato che la Non Conformità non è stata risolta in modo efficace, devi inserire qualcosa nelle note");
		}

		if (!this.__status_open && this.verificationData.consequencesIPM.trim() === "") {
			errors.push("Stai chiudendo una Non Conformità prima che sia partito il Cantiere, è obbligatorio inserire una motivazione nelle note");
		}

		return errors;
	}
}

Shark.registerModel("NotComplianceReport", NotComplianceReport);

export default NotComplianceReport;